import { QUESTIONS, createReader, formatDosage } from './documentData'
import { GOODS_EN, GUIDE_QUESTIONS, formatCompletionDate, formatNumber, sortNumerically, translate } from './guideData'

// Perguntas usadas só no Certificado de Expurgo e Exaustão de Gases
const GAS_FREE_QUESTIONS = {
  holds: 196, // filha ("PORÕES A SEREM TRATADOS", seleção múltipla), igual aos outros documentos
  // "DOSAGEM" por tipo de serviço da pai (fumigação 178/313/320, pest control 188, hold disinfection 544,
  // anti-salmonella 308, anti-fúngico 310 e ozônio 317): vale a primeira que tiver um número de g/m³
  dosages: [178, 188, 544, 308, 310, 313, 317, 320],
  // horas de exposição: perguntas alternativas (uma por lógica); vale a primeira respondida
  exposureTimes: GUIDE_QUESTIONS.exposureTimes.slice(0, 3)
}

// "1,0 g/m³" -> "1"; só aceita número (com ou sem a unidade g/m³), o resto (ex.: "0,4 ml por litro de água") fica vazio
const DOSAGE_PATTERN = /^(\d+(?:[.,]\d+)?)\s*(?:g\/m[³3])?$/i
const parseDosage = text => {
  const match = text.trim().match(DOSAGE_PATTERN)
  return match ? formatDosage(match[1]) : ''
}

// "1, 3" -> "1 e 3"; "1, 2, 5" -> "1, 2 e 5" (em inglês, "and")
export const joinHolds = (holds, conjunction) =>
  holds.length < 2 ? holds.join('') : `${holds.slice(0, -1).join(', ')} ${conjunction} ${holds[holds.length - 1]}`

// Primeira dosagem numérica respondida, na ordem das perguntas ("1,0 g/m³" -> "1"; "2,5 g/m³" -> "2,5")
export const findDosage = answer => GAS_FREE_QUESTIONS.dosages.map(id => parseDosage(answer(id))).find(Boolean) || ''

export const buildGasFreeData = ({ serviceOrder, childrenServiceOrders = [], assets = [] }) => {
  const { answer } = createReader({ serviceOrder, childrenServiceOrders, assets })

  const goods = answer(QUESTIONS.goods).toUpperCase()
  const holds = sortNumerically(answer(GAS_FREE_QUESTIONS.holds)).split(', ').filter(Boolean)
  const completionDate = formatCompletionDate(serviceOrder.endDate)
  const [monthEn = '', year = ''] = completionDate.en.split(', ')

  return {
    activityCode: serviceOrder.yearlyId || '',
    communicationNumber: answer(QUESTIONS.communicationNumber),
    datePt: completionDate.pt,
    monthEn,
    yearEn: year && `, ${year}`,
    holdsPt: joinHolds(holds, 'e'),
    holdsEn: joinHolds(holds, 'and'),
    tons: formatNumber(answer(QUESTIONS.quantity), 3),
    ship: answer(QUESTIONS.ship).toUpperCase(),
    goodsPt: goods,
    goodsEn: translate(GOODS_EN, goods),
    dosage: findDosage(answer),
    hours: GAS_FREE_QUESTIONS.exposureTimes.map(answer).find(Boolean) || '',
    port: answer(QUESTIONS.mapaPort).toUpperCase()
  }
}
